<template>
  <div class="diary">
    <!-- 提示 -->
    <div class="tips">
      <img src="@/assets/tips.png" />点击日历上日期，就可以写那一天的日记啦~
    </div>
    <!-- 日记簿 -->
    <div class="calendar" ref="calendar">
      <div class="month" ref="month">
        <span>{{month}}月</span>
        <span>{{year}}</span>
      </div>
      <div class="week" ref="week">
        <div>日</div>
        <div>一</div>
        <div>二</div>
        <div>三</div>
        <div>四</div>
        <div>五</div>
        <div>六</div>
      </div>
      <div class="day">
        <div class="grid" :style={borderColor:color} v-for="(item,index) in list" :key="index" @click="goEdit(item)">
          <div class="date" v-if="item.date">
            <span>{{item.date}}</span><br />
            <!-- <span>十五</span> -->
          </div>
          <div class="mood" v-if="item.mood">
            <img src="@/assets/mood1.png" v-if="item.mood == 'superHappy'" />
            <img src="@/assets/mood2.png" v-else-if="item.mood == 'happy'" />
            <img src="@/assets/mood3.png" v-else-if="item.mood == 'normal'" />
            <img src="@/assets/mood4.png" v-else-if="item.mood == 'sad'" />
            <img src="@/assets/mood5.png" v-else-if="item.mood == 'superSad'" />
          </div>
        </div>

      </div>
    </div>
    <!-- 上一月下一月 -->
    <div class="changeMonth">
      <div @click="handleChangeMonth('pre')">
        <img src="@/assets/pre.png">
        <span>上一月</span>
      </div>
      <div @click="handleChangeMonth('next')" :class="{grey:!enableNext}">
        <span>下一月</span>
        <img src="@/assets/next.png" v-if="enableNext">
        <img src="@/assets/nextGrey.png" v-else />
      </div>
    </div>
    <div class="mask" v-if="showMood">
      <div class="chooseMood">
        <div class="title">请选择你的心情</div>
        <div class="box">
          <div class="moods">
            <div @click="mood ='superHappy'" :class="{active:mood =='superHappy'}">
              <img src="@/assets/mood1.png" />
              非常开心
            </div>
            <div @click="mood ='happy'" :class="{active:mood =='happy'}">
              <img src="@/assets/mood2.png" />
              开心
            </div>
            <div @click="mood ='normal'" :class="{active:mood =='normal'}">
              <img src="@/assets/mood3.png" />
              一般
            </div>
            <div @click="mood ='sad'" :class="{active:mood =='sad'}">
              <img src="@/assets/mood4.png" />
              郁闷
            </div>
            <div @click="mood ='superSad'" :class="{active:mood =='superSad'}">
              <img src="@/assets/mood5.png" />
              悲伤
            </div>
          </div>
          <div class="start">
            <button @click="createDiary()">开始日记</button>
          </div>
        </div>
      </div>
    </div>
    <edit-diary v-if="showEdit" :pk="editPk" :showEdit.sync="showEdit" @getdate="getdate()" />
  </div>
</template>

<script>
import { POST, GET } from '@/utils/request'
import EditDiary from './components/EditDiary.vue'

import { types as LoginTypes } from "@/store/modules/login";
import { mapActions, mapState } from "vuex";

export default {
  name: "diary",
  data () {
    return {
      month: '',
      year: null,
      firstWeek: '', // 1号周几
      list: [],
      color: '#55c0a4',

      // 上一月下一月的月份
      todayTime: null,//现在的时间，判断能不能到下一个月
      // setTime:null,// 设置的时间
      nowMonth: null,//1~11的数字表示月份，可修改
      enableNext: false,//是否可以到下一月

      showMood: false,
      tag_date: '',
      mood: "",// superHappy,happy,norman,sad,superSad

      editPk: '',
      showEdit: false,
    }
  },
  components: {
    EditDiary
  },
  mounted () {
    this.getdate()
  },
  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
    }),
    // 获取当前日期和列表
    getdate () {
      this.list = []
      let dayArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      let date = new Date();
      if (this.nowMonth !== null) {
        date.setFullYear(this.year, this.nowMonth, 1)
        let time = date.getTime()
        if (time > this.todayTime) {
          this.enableNext = false
        } else {
          this.enableNext = true
        }
      } else {// 仅一次，记录当前时间
        // 设置每个月的1号
        date = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)
        this.todayTime = date.getTime()
      }

      this.nowMonth = date.getMonth()
      this.setColor(this.nowMonth)
      this.year = date.getFullYear()
      this.month = (date.getMonth() + 1) > 9 ? '' + (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      let monthDay = dayArr[date.getMonth()]
      if ((this.year % 4 == 0 && this.year % 100 != 0 || this.year % 400 == 0) && this.nowMonth == 1) {
        // 判断是否为闰年 且为2月的时候
        monthDay = 29
      }
      this.firstWeek = date.getDay() // 获取1号是周几

      for (let i = 0; i < this.firstWeek; i++) {
        this.list.push({})
      }

      for (let i = 1; i < monthDay + 1; i++) {
        let eachDay = i < 10 ? '0' + i : '' + i
        let obj = {
          date: eachDay,
          mood: ''
        }
        this.list.push(obj)
      }

      if (this.list.length % 7) {
        let nowLenth = 7 - this.list.length % 7
        for (let i = 0; i < nowLenth; i++) {
          this.list.push({})
        }
      }
      this.getDiaryList()
    },
    // 获取日记列表
    getDiaryList () {
      let month = this.year + '-' + this.month
      GET('/server/community/list_diary/?page_size=31&month=' + month)
        .then(data => {
          let res = data.results
          res.forEach(ele => {
            let index = parseInt(ele.tag_date.substr(8, 2)) + this.firstWeek - 1
            let date = parseInt(ele.tag_date.substr(8, 2)) < 10 ? '0' + parseInt(ele.tag_date.substr(8, 2)) : parseInt(ele.tag_date.substr(8, 2))
            let obj = {
              mood: ele.mood,
              date: date,
              pk: ele.pk
            }
            this.$set(this.list, index, obj)

          });
        })
    },
    // 开始写日记
    createDiary () {
      let callback = ()=>{
      if (!this.mood) {
        this.$message.error('请选择心情')
        return
      }
      POST('/server/community/create_diary/', {
        mood: this.mood,
        tag_date: this.tag_date
      })
        .then(res => {
          this.editPk = res.pk
          this.showEdit = true
          this.showMood = false
        })
      }
      this.dependLoginStatus().then(callback)
    },
    // 编辑日记
    goEdit (item) {
      if (item.pk) { // pk存在，则已经创建
        this.editPk = item.pk
        this.showEdit = true
      } else if (item.date) {
        this.showMood = true
        this.tag_date = this.year + '-' + this.month + '-' + item.date
      }
    },
    // 设置日记的color
    setColor (month) {
      let arr = ['#CA3E32', '#E4903B', '#EBD74F', '#6CB691', '#79B567', '#ECB449', '#D44D8D', '#D43D7A', '#464C97', '#383B8D', '#3666AB', '#4F8AC5'];
      let color = arr[month]
      this.$refs.calendar.style.borderColor = color
      this.$refs.month.style.color = color
      this.$refs.week.style.background = color
      this.color = color
    },
    // 处理上一月下一月的按钮
    handleChangeMonth (type) {
      if (type == 'pre') { // 上一月
        this.nowMonth--
        if (this.nowMonth < 0) {
          this.year--
          this.nowMonth = 11
        }
        this.getdate()
      } else if (type == 'next' && this.enableNext) { // 下一月
        this.nowMonth++
        if (this.nowMonth > 11) {
          this.year++
          this.nowMonth = 0
        }
        this.getdate()
      }

    }
  }
}
</script>

<style  lang="less" scoped>
@calendarColor: #55c0a4;
.diary {
  padding: 20px;
}
.tips {
  display: flex;
  font-size: 16px;
  color: #666666;
  align-items: center;
  img {
    width: 22px;
    margin-right: 10px;
  }
}
// 日历
.calendar {
  margin-top: 20px;
  width: calc(100% - 20px);
  border: 10px solid @calendarColor;
  border-radius: 10px;
  overflow: hidden;
  .month {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 30px);
    padding: 0 15px;
    height: 60px;
    color: @calendarColor;
    font-size: 32px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .week {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    height: 32px;
    background: @calendarColor;
    color: #fff;
    div {
      width: calc(100% / 7);
    }
  }
  .day {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .grid {
      width: calc((100% / 7) - 1px);
      height: 70px;
      border-right: 1px solid @calendarColor;
      flex-grow: 1;
      flex-grow: 0;
      border-bottom: 1px solid @calendarColor;
      position: relative;
      .date {
        position: absolute;
        left: 15px;
        bottom: 0;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: center;
      }
      .mood {
        position: absolute;
        top: 5px;
        right: 10px;
        img {
          display: block;
          width: 34px;
        }
      }
    }
    .grid.last {
      border-right: none;
    }
  }
}
// 上一月下一月
.changeMonth {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  color: #6b45e1;
  font-size: 18px;
  div {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 18px;
    }
    span {
      margin: 0 10px;
    }
  }
  div.grey {
    color: #909294;
    cursor: not-allowed;
  }
}
// 选择心情
// 请输入密码
.mask {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  z-index: 900;
}
.chooseMood {
  background: #644ed9;
  color: #ffffff;
  font-size: 28px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  .box {
    margin-top: 30px;
    border-radius: 14px;
    width: 100%;
    background: #ffffff;
    position: relative;
    overflow: hidden;
    .moods {
      display: flex;
      align-items: center;
      padding-right: 45px;
      text-align: center;
      color: #333333;
      font-size: 20px;
      padding-top: 40px;
      .active {
        transform: scale(1.1);
      }
      div {
        width: fit-content;
        margin-left: 45px;
        cursor: pointer;
        img {
          width: 100px;
          display: block;
        }
        &:hover {
          transform: scale(1.05);
        }
      }
    }
    .start {
      text-align: center;
      margin-top: 40px;
      margin-bottom: 30px;
      button {
        height: 50px;
        border-radius: 25px;
        color: #ffffff;
        background: #644ed9;
        font-size: 24px;
        padding: 0 40px;
        cursor: pointer;
      }
    }
  }
}
</style>